import {ReactNode} from "react";
import {Colors, Text} from "@bounce/shared/ui";

interface TooltipSummaryProps {
  children: ReactNode;
}

export const TooltipSummary = ({children}: TooltipSummaryProps) => (
  <Text size={13} sx={{color: Colors.grey._800, lineHeight: 1.5}}>
    {children}
  </Text>
);
